<template>
  <div>
    <b-row>
      <b-col ><h3>{{productName}}</h3></b-col>
      <b-col><h3>Hostname</h3></b-col>
    </b-row>

    <b-row  v-for="(item,key) in orderlistC"
            v-if="item.product_name === productName"
           :key="item.product_key">
        <b-col >{{item.product_key}}</b-col>
        <b-col ><input class="mb-2" type="text" v-model="item.hostname"></b-col>
    </b-row>
  </div>
</template>

<script>
  import {VserverOrderList} from "@/store/models/vserver/vserver_order_list";

  export default {
        name: "luma-order-modal-list-vserver",
    data:()=>({
      orderlist:[]
    }),
    props:{
      productKey:String,
      productName:String
    },
    computed:{
          //creates vserver instances of product amount [VserverOrder[product_key].amount * new VserverOrder]
          orderlistC(){
            if(!VserverOrderList.all().length) return
            return VserverOrderList.all()
          }

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datacenter/vserver_datacenter/luma-order-modal-list-vserver.vue